module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    attrs: {
      "id": "form-header"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.petitionCount))]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("people want to protect Australian wildlife.")]), _vm._v(" "), _c('p', [_vm._v("Add your voice.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff4eee94","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/threatened-species/form-components/Header.vue
// module id = 869
// module chunks = 0